import './components/notification-manager';
import './pages/notification_settings';

global.notificationInit = () => import('./components/notification-window').then(module => module.notificationInit());
